import * as tslib_1 from "tslib";
import * as React from 'react';
import { StyledIconBase } from '../../StyledIconBase';
export var Eyedropper = React.forwardRef(function (props, ref) {
    var attrs = {
        "fill": "currentColor",
    };
    return (React.createElement(StyledIconBase, tslib_1.__assign({ iconAttrs: attrs, iconVerticalAlign: "middle", iconViewBox: "0 0 24 24" }, props, { ref: ref }),
        React.createElement("path", { fill: "none", d: "M15.584 10.001l-1.586-1.584-8.095 8.095-.529 2.114 2.114-.529z", key: "k0" }),
        React.createElement("path", { d: "M4.03 15.758l-1 4a.997.997 0 0 0 1.212 1.212l4-1c.176-.044.337-.135.465-.263l8.292-8.292 1.294 1.292 1.414-1.414-1.294-1.292L21 7.414c.378-.378.586-.88.586-1.414S21.378 4.964 21 4.586L19.414 3c-.756-.756-2.072-.756-2.828 0l-2.589 2.589-1.298-1.296-1.414 1.414 1.298 1.296-8.29 8.29a1.001 1.001 0 0 0-.263.465zm1.873.754l8.095-8.095 1.586 1.584-8.096 8.096-2.114.529.529-2.114z", key: "k1" })));
});
Eyedropper.displayName = 'Eyedropper';
export var EyedropperDimensions = { height: 24, width: 24 };
